import VerticalNavItem from "./VerticalNavItem";
import classNames from 'classnames';
import { createElement as _createElement } from "preact/compat";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/vertical-navigation/).
 */
export const VerticalNav = props => {
  const classes = classNames({
    'ds-c-vertical-nav': !props.nested,
    'ds-c-vertical-nav__subnav': props.nested,
    'ds-c-vertical-nav--collapsed': props.collapsed
  }, props.className);
  const navProps = props.ariaNavLabel ? {
    'aria-label': props.ariaNavLabel
  } : {};
  const navList = /*#__PURE__*/_jsx("ul", {
    role: "list",
    className: classes,
    id: props.id,
    children: props.items.map(item => {
      let onClick = item.onClick || props.onLinkClick;
      if (!onClick) {
        onClick = undefined;
      }
      const selected = item.selected || props.selectedId && props.selectedId === item.id;
      return /*#__PURE__*/_createElement(VerticalNavItem, {
        ...item,
        component: props.component || item.component,
        _selectedId: props.selectedId,
        key: item.id + item.url + item.label,
        onClick: onClick,
        selected: selected
      });
    })
  });
  return props.nested ? navList : /*#__PURE__*/_jsx("nav", {
    ...navProps,
    children: navList
  });
};
VerticalNav.defaultProps = {
  collapsed: false
};
export default VerticalNav;